import 'regenerator-runtime/runtime';
import { takeEvery } from 'redux-saga/effects';
import { GlobalActions, ShopTarifierungRequestEvents } from '@ps20-frontend/shop-integration-redux';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import { TaasPhData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { buildTaasPhDataForShop } from './transformer/phData.transformer';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasPhData
>(App.PH);
export const shopTarifierer = new ShopTarifierer({
  appId: App.PH,
  taasDataBuilder: buildTaasPhDataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungPH(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_PH,
    safeSaga(shopTarifierer.handleSuccess, App.PH),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(shopTarifierer.callTarifierung, App.PH),
  );
}
